module.exports = __webpack_public_path__ + "img/電気回路_4_1.26b98ea4.png";